import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";

import { getAuthRoleNames } from "../../../../services/authService";

const Suspended = () => {
  const { t } = useTranslation();
  const isOwner = getAuthRoleNames().includes("owner");

  useEffect(() => {
    document.title = t("subscription.suspended.pageTitle");
  }, [t]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6} xl={5} className="text-center py-5">
            <div className="avatar-lg mx-auto mb-4">
              <div className="avatar-title bg-danger-subtle text-danger rounded-circle fs-1">
                <i className="ri-error-warning-line" aria-hidden="true" />
              </div>
            </div>
            <h4 className="mb-3">{t("subscription.suspended.title")}</h4>
            <p className="text-muted mb-4">{t("subscription.suspended.message")}</p>
            {isOwner ? (
              <Link to="/settings/subscription">
                <Button color="primary">{t("subscription.suspended.manageButton")}</Button>
              </Link>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Suspended;
